// ML001-F0213 (apply / unapply a credit note to an invoice) and ML001-F0223 (history_key). The client for the four credit_allocation
// operations, relayed by Core's GENERIC module relay: POST /api/v1/orgs/:orgId/modules/ledger/messages with the closed envelope
// { relay_version: 1, type, payload }. Core reads only `type` and forwards `payload` unread, so nothing here is a Core rule.
// Coded to Spec core-ledger-account-gateway 1.10.0 (interface.json: credit_allocation.list / .apply / .unapply / .reapply).
// Reads need billing_transactions_view; writes need ledger_manage at SAL 4 (step-up: STEP_UP_REQUIRED, handled by the caller).
// `apply` requires an Idempotency-Key; the caller owns the key so that a step-up retry of the SAME attempt reuses it.
import api from './api';

const messagesPath = (orgId) => `/v1/orgs/${encodeURIComponent(orgId)}/modules/ledger/messages`;
const envelope = (type, payload) => ({ relay_version: 1, type, payload });

// Core answers { success, data: { relay_version, request_id, module, type, payload } }; `payload` is the Ledger's answer.
export const relayPayloadOf = (response) => response?.data?.data?.payload ?? null;

export const creditAllocationApi = {
  list: (orgId, filters = {}) => api.post(messagesPath(orgId), envelope('credit_allocation.list', filters)),
  apply: (orgId, body, idempotencyKey) => api.post(
    messagesPath(orgId),
    envelope('credit_allocation.apply', body),
    { headers: { 'Idempotency-Key': idempotencyKey } },
  ),
  unapply: (orgId, body) => api.post(messagesPath(orgId), envelope('credit_allocation.unapply', body)),
  // M004-F0757 (WebUI #200): Apply to account, Spec core-ledger-account-gateway credit.allocate_to_account. Body is exactly
  // { credit_note_id, amount_minor, comment } (additionalProperties false; comment required since Spec 1.19.0).
  allocateToAccount: (orgId, body, idempotencyKey) => api.post(
    messagesPath(orgId),
    envelope('credit.allocate_to_account', body),
    { headers: { 'Idempotency-Key': idempotencyKey } },
  ),
  // M004-F0757 (WebUI #201): Refund CR, Spec 1.17.0 credit.refund. Writes need ledger_manage at SAL 4; `refund` requires an Idempotency-Key.
  refund: (orgId, body, idempotencyKey) => api.post(
    messagesPath(orgId),
    envelope('credit.refund', body),
    { headers: { 'Idempotency-Key': idempotencyKey } },
  ),
};
